<template>
	<v-container>
		<v-row>
			<v-col cols="6">
				<v-card v-if="isRedirect">
					<v-card-title class="d-flex align-center">
						<v-icon
							icon="$test"
							start
						/>
						Adyen Test Redirect
					</v-card-title>
					<v-card-text>
						{{ redirectText }}
					</v-card-text>
				</v-card>
				<v-card v-else>
					<v-card-title class="d-flex align-center">
						<v-icon
							icon="$test"
							start
						/>
						<translate>Adyen Test</translate>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col>
								<price-field
									v-model="price"
									label="Price"
									variant="outlined"
								/>
							</v-col>
							<v-col>
								<v-btn
									color="primary"
									@click="getSessionData"
								>
									<translate>Set</translate>
								</v-btn>
							</v-col>
						</v-row>
						<div
							id="card-container"
						/>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							v-if="checkoutComponent"
							color="primary"
							@click="checkoutComponent.submit()"
						>
							<translate>Continue</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {
	default as adyenCheckout,
} from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import axios from 'axios';

export default {
	name: 'TestAdyen',
	data () {
		return {
			price: '1.00',
			checkout: null,
			checkoutComponent: null,
			isRedirect: false,
			redirectText: '',
			configuration: {
				environment: 'test', // Change to 'live' for the live environment.
				clientKey: 'test_45DRABTLZVB5VHESEFA6YTM7LYYQUGPD', // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
				analytics: {
					enabled: true // Set to false to not send analytics data to Adyen.
				},
				session: {
					id: '', // Unique identifier for the payment session.
					sessionData: '' // The payment session data.
				},

				onPaymentCompleted: (result) => {
					this.redirectText = result.resultCode;

				},
				onError: (error) => {
					window.captureException(error);
					this.isRedirect = false;
				},
			}
		};
	},

	async created () {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		const sessionId = params.get('sessionId');
		const redirectResult = params.get('redirectResult');

		if (sessionId && redirectResult) {
			this.isRedirect = true;
			await this.handleRedirect(sessionId, redirectResult);
		}
	},

	methods: {
		/**
		 * Handle a redirect session
		 *
		 * @param {string} sessionId
		 * @param {string} redirectResult
		 */
		async handleRedirect (sessionId, redirectResult) {
			this.configuration.session.id = sessionId;
			this.checkout = await adyenCheckout(this.configuration);
			this.checkout.submitDetails({
				details: {
					redirectResult: redirectResult
				}
			});

		},

		/**
		 * Get session data and mount the checkout component based on the data
		 */
		getSessionData () {
			axios.get(`/bo/testing/adyen/session?price=${this.price}`)
				.then(async ({
					data
				}) => {
					this.configuration.session = data;
					this.checkout = await adyenCheckout(this.configuration);

					this.checkoutComponent = this.checkout.create('ideal').mount('#card-container');
				});
		},
	}
};
</script>

<style scoped>

</style>
